export const BRANDFETCH_CLIENT_ID = '1idLfLHGCJTwPdNacnT';

function cleanText(value) {
  return String(value || '').trim();
}

export function normalizeDomainForBrandfetch(value) {
  const raw = cleanText(value);
  if (!raw) return null;

  const normalizedInput = raw.startsWith('http://') || raw.startsWith('https://')
    ? raw
    : `https://${raw}`;

  try {
    const { hostname } = new URL(normalizedInput);
    const cleanedHostname = cleanText(hostname).replace(/^www\./i, '').toLowerCase();
    return cleanedHostname || null;
  } catch {
    return null;
  }
}

export function buildBrandfetchLogoUrl(domainOrUrl) {
  const domain = normalizeDomainForBrandfetch(domainOrUrl);
  if (!domain) return null;
  return `https://cdn.brandfetch.io/${encodeURIComponent(domain)}?c=${BRANDFETCH_CLIENT_ID}`;
}
